export const MAX_COMMENT_LENGTH = 1000;
export const MIN_COMMENT_LENGTH = 100;